
export default function Footer() {
  return (
    <footer className="bg-cipher-black text-white pt-24 pb-12 border-t border-gray-900">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-8 mb-24">
          
          {/* Brand Column */}
          <div className="md:col-span-5">
            <h2 className="text-3xl font-black mb-6">Negotrix</h2>
             <p className="text-gray-300 font-medium text-lg max-w-sm">
              We help growing companies build commercial confidence through commercial intelligence, negotiation expertise, and strategic vendor partnerships across SaaS, infrastructure, marketing & enterprise contracts.
            </p>
          </div>

          {/* Nav Columns */}
          <div className="md:col-span-2">
            <h3 className="text-xs tracking-widest text-gray-500 uppercase font-bold mb-6">Company</h3>
            <ul className="space-y-4">
              <li><a href="/about" className="text-lg font-bold hover:text-cipher-hypergreen transition-colors">About Us</a></li>
              <li><a href="/how-it-works" className="text-lg font-bold hover:text-cipher-hypergreen transition-colors">How It Works</a></li>
              <li><a href="/success-stories" className="text-lg font-bold hover:text-cipher-hypergreen transition-colors">Success Stories</a></li>
              <li><a href="/contact" className="text-lg font-bold hover:text-cipher-hypergreen transition-colors">Careers</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-xs tracking-widest text-gray-500 uppercase font-bold mb-6">Expertise</h3>
            <ul className="space-y-4">
              <li><a href="/saas-software" className="text-lg font-bold hover:text-cipher-hypergreen transition-colors">SaaS &amp; Software</a></li>
              <li><a href="/infrastructure-cloud" className="text-lg font-bold hover:text-cipher-hypergreen transition-colors">Infrastructure</a></li>
              <li><a href="/marketing-advertising" className="text-lg font-bold hover:text-cipher-hypergreen transition-colors">Marketing</a></li>
              <li><a href="/vendor-contracts" className="text-lg font-bold hover:text-cipher-hypergreen transition-colors">Vendor Contracts</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-xs tracking-widest text-gray-500 uppercase font-bold mb-6">Connect</h3>
            <ul className="space-y-4">
              <li><a href="mailto:amit@negotrix.com" className="text-lg font-bold hover:text-cipher-hypergreen transition-colors">Get in Touch</a></li>
              <li><a href="https://www.linkedin.com/company/negotrix" target="_blank" rel="noopener noreferrer" className="text-lg font-bold hover:text-cipher-hypergreen transition-colors">LinkedIn</a></li>
            </ul>
          </div>

        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
          <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0">
            <p className="text-xs sm:text-sm text-gray-400 text-center sm:text-left">
               © 2026 Negotrix . All rights reserved.
            </p>
          </div>
          <div className="flex space-x-4 sm:space-x-6">
            <a href="/privacy-policy" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors focus-ring rounded px-1">Privacy Policy</a>
            <a href="/terms-of-service" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors focus-ring rounded px-1">Terms of Service</a>
          </div>
        </div>

      </div>
    </footer>
  );
}
